import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BcpCrypto } from '@bcp/js-crypto';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';   
import { environment } from 'src/environments/environment';
import { CryptoService } from '../infraestructure/services/crypto.service';
import { Secret } from '../domain/model/secret';

function initialize(cryptoService: CryptoService) {
  return async () => {
    // Aquí puedes descomentar y usar la llamada HTTP si es necesario
    // const { iv, password } = await lastValueFrom(http.get<Secret>(`${environment.APIUX}/api-agnostic-crypto/secrets`));
    cryptoService.setCredentials('', '');
  };
}

@NgModule({
  providers: [
    CryptoService,
    {
      provide: BcpCrypto,
      useFactory: () => BcpCrypto.getInstance(),
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initialize,
      deps: [CryptoService],
      multi: true
    }
  ],
  imports: [
    HttpClientModule,
  ]
})
export class CryptoModule { }
